module.exports = __webpack_public_path__ + "static/media/haylie-brae-on-naked-news-sep-13-15-f1b7d15a_thumbnail.39f7dff5.png";